import { render } from "./GalleryImageDetail.vue?vue&type=template&id=24ca5430&scoped=true"
import script from "./GalleryImageDetail.vue?vue&type=script&lang=js"
export * from "./GalleryImageDetail.vue?vue&type=script&lang=js"

import "./GalleryImageDetail.vue?vue&type=style&index=0&id=24ca5430&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24ca5430"

export default script